import {
  BASE_URL,
  DASHBOARD_STATS,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchStatisticsData = async (reportName) => {
  let response = await fetch(`${BASE_URL}${DASHBOARD_STATS}/${reportName}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const fetchStatisticsResponse = async (reportName) => {
  let response = await fetch(`${BASE_URL}${DASHBOARD_STATS}/${reportName}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};
